export function setupCaseEntrance() {
    const caseEntranceItems = document.querySelectorAll('.case-entrance__item');

    Array.from(caseEntranceItems).forEach(item => {
        const paragraph = item.querySelector('p');

        if (paragraph) {
            const height = paragraph.scrollHeight;

            paragraph.setAttribute('data-height', height);
        }

        function enterCaseEntranceItem(e) {
            const item = e.target.closest('.case-entrance__item');

            if (item) {
                const paragraph = item.querySelector('p');
                const content = item.querySelector('.case-entrance__content-wrap');

                if (paragraph && content) {
                    const height = paragraph.getAttribute('data-height');
                    paragraph.style.height = `${height}px`;
                    content.style.marginTop = `-${height}px`;
                }
            }
        }

        function leaveCaseEntranceItem(e) {
            const item = e.target.closest('.case-entrance__item');

            if (item) {
                const paragraph = item.querySelector('p');
                const content = item.querySelector('.case-entrance__content-wrap');

                if (paragraph && content) {
                    paragraph.style.height = null;
                    content.style.marginTop = null;
                }
            }
        }

        item.addEventListener('mouseenter', enterCaseEntranceItem);
        item.addEventListener('mouseleave', leaveCaseEntranceItem);
    });
}